<template>
  <v-card class="mb-0 " :width="width" outlined>
    <v-list-item three-line>
       <div>
          <files-icon class="py-3" :fileType="get_url_extension(fileUrl)" :width="iconWidth" :showBadge="false" ></files-icon>
      </div>

      <v-list-item-content class="px-2">
        <div :title="fileFullName" class="mb-0 text-wrap" v-if="get_file_name_from_url(fileUrl)">
          {{get_file_name_from_url(fileUrl)}}
        </div>
        <v-list-item-subtitle>
            {{get_url_extension(fileUrl).toUpperCase()}}
          <span v-if="fileSizeFormat">({{fileSizeFormat}})</span>
       
         </v-list-item-subtitle>

      </v-list-item-content>

    </v-list-item>

    <v-card-actions>
      <v-btn class="px-3" outlined rounded text @click="downLoadFile(fileUrl)">
        {{$t('Download')}}
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
       <v-btn @click="onDeleteItem(item)" :title="$t('delete')"  rounded icon  v-if="item && showDeleteBtn">
             <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import filesIcon from "./filesIcon.vue";
export default {
  components: { filesIcon },
  data() {
    return {
fileFullName:''
    };
  },
  props: {
    fileUrl: {
      type: String
    },
    width: {
      type: Number,
      default: 300
    },
    fileNameLength:{
         type: Number,
      default: 25
    }, 
     fileSizeFormat: {
      type: String,
      default:""
    },
    iconWidth:{
         type: Number,
      default: 64
    },
    deleteItem:{
      type:Function,
      default:null
    },
     showDeleteBtn:{
      type:Boolean,
      default:false
    },
     item:{
      type:Object,
      default:null
    }


  },
  methods: {
    onDeleteItem(item){
      if(this.deleteItem){
        this.deleteItem(item);
      }
    },
    get_url_extension(url) {
      return url
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim().toLowerCase();
    },
    get_file_name_from_url(url) {
      var matches = url.match(/\/([^\/?#]+)[^\/]*$/);
      if (matches&&matches.length > 1) {
          this.fileFullName=matches[1];
          if( matches[1].length>this.fileNameLength){
              return matches[1].substr(0,this.fileNameLength-1)
          }
        return matches[1];
      }
      return "no name";
    },
    downLoadFile(url){
       window.open(url,'_blank');
    }
  }
};
</script>
<style scoped>
.v-application .text-wrap {
    white-space: normal !important;
    overflow-wrap: anywhere;
}
.v-card__actions{
    padding-top: 0;

}

</style>